class AthaColorSwatches {
  constructor() {
    this.container = document.getElementById("atha-color-swatches-container");
    if (!this.container) return;

    this.move();

    const productInfo = document.querySelector("product-info");
    if (!productInfo) return;

    this.observer = new MutationObserver(() => {
      this.move();
    });

    this.observer.observe(productInfo, {
      childList: true,
      subtree: true
    });
  }

  move() {
    const picker = document.querySelector("variant-selects");
    if (!picker) return;

    // Already in the correct position
    if (this.container.previousElementSibling === picker) return;

    picker.insertAdjacentElement("afterend", this.container);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new AthaColorSwatches();
});